// Privacy Policy + Terms versioning — imported by both server (consent gate) and client (documents, gate UI).
// Bump POLICY_VERSION whenever the text changes materially; every user is then asked to re-accept in-app.
export const POLICY_VERSION = '2026-09-21';
export const POLICY_EFFECTIVE_TH = '21 กันยายน 2569';
export const POLICY_VERSION_LABEL = '1.1';
/** Booking terms (section 13 of /terms) are versioned separately and stamped on every booking. */
export const BOOKING_TERMS_VERSION = '2026-09-21';

/** Message the server returns (403, reason 'policy') until the current version has been accepted. */
export const POLICY_REQUIRED_MESSAGE = 'กรุณายอมรับนโยบายความเป็นส่วนตัวและข้อกำหนดก่อนใช้งาน';
